import { render, staticRenderFns } from "./tablev1.vue?vue&type=template&id=f14b8484&"
import script from "./tablev1.vue?vue&type=script&lang=ts&"
export * from "./tablev1.vue?vue&type=script&lang=ts&"
import style0 from "./tablev1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports